<template>
    <div>
        <div 
        class="tw-overflow-hidden"
        :style="{
            height: (!loading && errors.length == 0) ? null : 0
        }">
            <form :action="formAction" method="POST" target="accept-hosted" ref="activator">
                <input type="hidden" name="token" :value="token">
            </form>

            <iframe v-show="!complete" id="accept-hosted" name="accept-hosted" width="100%" frameborder="0" scrolling="yes" :height="frameHeight" @load="onIframeLoaded">
            </iframe>
            
            <transition name="fade">
                <div v-show="complete">
                    <div class="tw-text-center tw-border-b tw-pb-4 tw-mb-4">
                        <i class="fa fa-check fa-2x text-success tw-mb-2 tw-p-2 tw-border-2 tw-border-green-600 tw-rounded-full"></i>
                        <h3 class="tw-font-bold text-success">Payment details received</h3>
                    </div>
                    <base-loader :active="true" :overlay="false" text="Finalizing your payment"></base-loader>
                </div>
            </transition>
        </div>

        <base-loader :active="loading && errors.length == 0" :overlay="false"></base-loader>

        <div v-show="errors.length > 0">
            <div class="alert alert-danger tw-mb-0">{{ errors.flat().join(' ') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AcceptHosted",

    props: {
        order: {
            type: Number
        },
        environment: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            token: null,
            loading: true,
            complete: false,
            errors: [],
            frameHeight: 0
        }
    },

    computed: {
        formAction() {
            return this.environment == 'LIVE' ? 'https://accept.authorize.net/payment/payment' : 'https://test.authorize.net/payment/payment';
        }
    },

    mounted() {
        if(this.order) {
            // Generate a token for the given order
            this.getToken();
        }

        // Listen for the "token" event from the create-online-transaction component
        // This will only be used in the payment portal
        EventBus.$on('token', event => {
            this.loadForm(event);
        })

        // Listen for messages from the iframe
        EventBus.$on('message', event => this.onMessage(event));
    },

    methods: {
        onIframeLoaded() {
            this.loading = false;

            if(!this.frameHeight) {
                this.frameHeight = 700;
            }
        },

        getToken() {
            this.loading = true;

            // Send a request to generate a form token for the current order
            axios.get(`/api/order/${this.order}/token`)
                .then(response => {
                    // Token generation successful
                    this.loadForm(response.data);
                })
                .catch(error => {
                    this.errors = ['The payment form could not be loaded, please contact support.'];
                    this.loading = false;
                })
        },

        loadForm(token) {
            // Store the token, and submit the form to load the iframe
            this.token = token;

            this.$nextTick(() => {
                this.$refs.activator.submit();
            });

        },

        parseQueryString(str) {
            var vars = [];
            var arr = str.split('&');
            var pair;
            for (var i = 0; i < arr.length; i++) {
                pair = arr[i].split('=');
                vars[pair[0]] = unescape(pair[1]);
            }
            return vars;
        },

        onMessage(event) {
            let params = this.parseQueryString(event.qstr);

            switch(params.action) {
                case "resizeWindow" :
                    this.frameHeight = params.height + 20;
                    break;
                case "cancel":
                    this.token = null;
                    this.loading = true;
                    this.$emit('cancel');
                    break;
                case "transactResponse":
                    // Payment complete
                    let response = JSON.parse(params.response)

                    this.displayIFrame = false;
                    this.complete = true;

                    // Redirect to capture the authorized transaction
                    const form = document.createElement('form');
                    form.method = 'POST';
                    form.action = '/transaction/capture';

                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = 'authorizeTransactionId';
                    input.value = response.transId;
                    form.appendChild(input);

                    const csrf = document.createElement('input');
                    csrf.type = 'hidden';
                    csrf.name = '_token';
                    csrf.value = document.querySelector('meta[name="csrf-token"]').content;
                    form.appendChild(csrf);

                    document.body.appendChild(form);
                    form.submit();

                    break;
            }
        }
    }
}
</script>

<style>

</style>